module.exports = __webpack_public_path__ + "static/media/arborea4.4489d708.webp";